module.exports = window["wc"]["currency"];